import React from 'react';
import {Field} from 'redux-form/immutable';
import {TextAreaField, SelectField} from 'redux-form-antd'
import {
    nullValue1,
    required,
    nullValue0
} from "../validDesc";

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const Ans1 = props => {
    const major_injury_card_select = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '沒有'
        },
        {
            value: '2',
            label: '有'
        },
    ]
    const national_health_insurance_select = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '否'
        },
        {
            value: '2',
            label: '是'
        }
    ]
    const proof_of_physical_disability_select = [
        {
            value: '0',
            label: '請選擇'
        },
        {
            value: '1',
            label: '沒有'
        },
        {
            value: '2',
            label: '有，請於開學時檢附資料。'
        },
    ]

    return (
        <div>
            <h3>先天疾病或意外引起的缺陷或殘障：</h3>
            <div className="ml-20">
                <Field component={TextAreaField} label='說明：'
                       name="disability_remark" rows="3"/>
                <Field {...formItemLayout} validate={[required, nullValue0]} component={SelectField} label='是否有身心障礙證明'
                       options={proof_of_physical_disability_select} name="proof_of_physical_disability" type="text" disabled={false}></Field>
                <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='是否有重大傷病卡'
                       options={major_injury_card_select} name="disability_card" type="text" disabled={false}></Field>
            </div>
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label='是否有全民健保'
                   options={national_health_insurance_select} name="health_insurance" type="text" disabled={false}></Field>
            <h3>若遇學生情況緊急，聯絡不到家長時，由學校權宜處理。</h3>
        </div>
    )
}

export default Ans1


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/HealthQuestionnaireContaioner/HealthQuestionnaireForm/Disability.jsx